import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from '@cuemath/comps';

import {
  ModalOverlay,
  ModalBox,
  ModalTitle,
  ModalText,
  ModalActions,
  ModalCancelButton,
} from '../tabs/dispositions/styled-comps';

const OutlineButton = styled(Button)`
  && {
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 600;
    color: ${({ $color }) => $color};
    background: transparent;
    border: 1px solid ${({ $color }) => $color};
    border-radius: 4px;
    cursor: pointer;
    height: auto;
    transition: opacity 0.15s ease;
  }

  && > * {
    border: none;
    padding: 0;
    background: transparent;
  }
  &&:hover {
    opacity: 0.85;
    border: 1px solid ${({ $color }) => $color};
  }
  &&:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ConfirmButton = styled(Button)`
  && {
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    background: ${({ $bg }) => $bg};
    border: 1px solid ${({ $bg }) => $bg};
    border-radius: 4px;
    cursor: pointer;
    height: auto;
  }

  && > * {
    border: none;
    padding: 0;
    background: transparent;
  }
  &&:hover {
    opacity: 0.9;
    border: 1px solid ${({ $bg }) => $bg};
  }
`;

function ConfirmButtonWithModal({
  label,
  color,
  confirmBg,
  title,
  description,
  confirmLabel,
  onConfirm,
  disabled,
}) {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleConfirm = () => {
    setShowConfirm(false);
    onConfirm();
  };

  return (
    <>
      <OutlineButton
        label={label}
        $color={color}
        onClick={() => setShowConfirm(true)}
        disabled={disabled}
      />
      {showConfirm && (
        <ModalOverlay onClick={() => setShowConfirm(false)}>
          <ModalBox onClick={e => e.stopPropagation()}>
            <ModalTitle>{title}</ModalTitle>
            <ModalText>{description}</ModalText>
            <ModalActions>
              <ModalCancelButton label="Cancel" onClick={() => setShowConfirm(false)} />
              <ConfirmButton
                label={confirmLabel || label}
                $bg={confirmBg}
                onClick={handleConfirm}
              />
            </ModalActions>
          </ModalBox>
        </ModalOverlay>
      )}
    </>
  );
}

export function UnpublishButton({ onUnpublish, disabled, noun = 'version' }) {
  return (
    <ConfirmButtonWithModal
      label="Unpublish"
      color="#b26a00"
      confirmBg="#f29d1f"
      title="Confirm Unpublish"
      description={`Unpublishing will archive this ${noun} and leave no published row. Continue?`}
      onConfirm={onUnpublish}
      disabled={disabled}
    />
  );
}

export function RestoreButton({ onRestore, disabled }) {
  return (
    <ConfirmButtonWithModal
      label="Restore & Publish"
      color="#0177ff"
      confirmBg="#0177ff"
      title="Restore archived version"
      description="This copies the archived snapshot into a new DRAFT and immediately publishes it. The current PUBLISHED row (if any) will be archived."
      confirmLabel="Restore & Publish"
      onConfirm={onRestore}
      disabled={disabled}
    />
  );
}
